import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import ScheduleEditor from "../schedule/ScheduleEditor";
import { ScheduleWorkspaceContext } from "../schedule/scheduleWorkspaceContext";
import "./ScheduleWorkspaceModal.scss";

export default function ScheduleWorkspaceModal({
  open,
  scheduleId,
  studyRow = null,
  onClose,
}) {
  useEffect(() => {
    if (!open) return undefined;
    const previous = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = previous;
    };
  }, [open]);

  if (!open || !scheduleId) return null;

  return createPortal(
    <div
      className="modal fade show d-block schedule-workspace-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="schedule-workspace-title"
    >
      <div className="modal-dialog schedule-workspace-modal__dialog study-add-edit-modal">
        <div className="modal-content schedule-workspace-modal__content">
          <ScheduleWorkspaceContext.Provider
            value={{
              embedded: true,
              onClose: onClose || (() => {}),
              scheduleId: String(scheduleId),
              studyRow,
            }}
          >
            <ScheduleEditor />
          </ScheduleWorkspaceContext.Provider>
        </div>
      </div>
    </div>,
    document.body,
  );
}
